import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';

import { IGameShowRunSettings } from 'app/teacher/gameshow/models/gameshow-run-settings';
import { GameShowService } from 'app/teacher/gameshow/services/gameshow.service';
import { TeacherService } from 'app/teacher/services/teacher.service';

@Injectable({
  providedIn: 'root'
})
export class GameShowSettingsResolver {
  readonly gameShowService = inject(GameShowService);
  private readonly teacherService = inject(TeacherService);

  public resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<IGameShowRunSettings> {
    const classId = this.teacherService.activeClassInfo?.ClassId ?? '';
    const publicUnitId = route.paramMap.get('publicUnitId') ?? '';
    return this.gameShowService.getGameShowSettings(classId, publicUnitId);
  }
}
